import Footer from "../component/layout/Footer";
import Header from "../component/layout/Header";
import WatchCourse from "../component/MyCourseViewComponents/WatchCourse";
import HomeBackground from '../assets/images/HomeBackground.png';
import Layout from "../component/layout/Layout";
import Loader from "../component/Loader/Loader";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchAllModuleOfCourse, fetchSingleCourse } from "../helper/course_helper";
import { generatePresignedUrlForAccess } from "../helper/content_helper";
import { getQuestionsByAssessment } from "../helper/assessment_helper";
import { getStudentProgress, updateProgress } from "../helper/progress_helper";

const MyCourseView = () => {
    const [loader, setLoader] = useState(false);
    const [course, setCourse] = useState({});
    const [modules, setModules] = useState([]);
    const [contentLink, setContentLink] = useState(null);
    const [contentType, setContentType] = useState(null);
    const [contentDescription, setContentDescription] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [lessonIndex, setLessonIndex] = useState(0);
    const [moduleIndex, setModuleIndex] = useState(0);
    const navigate = useNavigate();
    const params = useParams();

    const fetchCourse = async () => {
        try {
            setLoader(true);
            const data = await fetchSingleCourse(params.id);

            if (data?.success) {
                setCourse(data?.result?.[0]);
                fetchModules(data?.result?.[0]);
            } else {
                toast.error(data?.message);
            }

        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchCourse();
    }, []);

    useEffect(() => {
        // Check if 'student' exists in localStorage
        const student = localStorage.getItem('student');

        // If 'student' is not found, navigate to the login page
        if (!student) {
            navigate('/login');
        }
    }, [navigate]);


    const fetchModules = async (c) => {
        try {
            setLoader(true);
            let courseDto = c;
            const data = await fetchAllModuleOfCourse(courseDto);
            if (data?.success) {
                setModules(data?.result);
                fetchModuleProgress(data?.result);
                handleGenerateLink(data?.result[0]?.lessons[0]);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }
    }

    const handleGenerateLink = async (lesson) => {
        setLoader(true);  // Set loading to true when link generation starts
        console.log("contentType", lesson?.contentType);
        if (lesson?.contentType === "Pdf" || lesson?.contentType === "PPT") {
            handleVideoEnd();
        }
        try {
            const response = await generatePresignedUrlForAccess({ name: lesson.url, type: lesson.contentType });
            setContentLink(response.presignedUrl);
            setContentType(lesson.contentType);
            setContentDescription(lesson.lessonDescription);
        } catch (error) {
            console.error('Error generating link:', error);
        } finally {
            setLoader(false);  // Set loading to false once the link is generated
        }
    };

    const handleVideoEnd = async () => {
        try {
            const studentId = JSON.parse(localStorage.getItem("student")).id;
            const ids = studentId + "/" + modules[moduleIndex]?.id + "/" + lessonIndex;
            console.log(ids)
            const data = await updateProgress(ids);
            let moduless = modules;
            moduless[moduleIndex].progress.lessonTrack[lessonIndex] = true
            setModules(moduless);


        } catch (error) {
            console.log(error);
        }
    };

    const fetchModuleProgress = async (modules) => {
        try {

            const studentId = JSON.parse(localStorage.getItem("student")).id;

            // Create a shallow copy of the modules array to avoid mutating the original state
            const updatedModules = [...modules];

            for (let i = 0; i < updatedModules.length; i++) {
                const data = await getStudentProgress(studentId + "/" + updatedModules[i].id);

                if (data?.success) {
                    // Unlock the next module if the current one has an assessment
                    if (data?.result[0]?.assessment && updatedModules[i + 1]) {
                        updatedModules[i + 1] = {
                            ...updatedModules[i + 1], // Shallow copy of the next module
                            status: "UNLOCK", // Update its status to 'UNLOCK'
                        };
                    }

                    // Update the progress for the current module
                    updatedModules[i] = {
                        ...updatedModules[i], // Shallow copy of the current module
                        progress: data?.result[0], // Update its progress
                    };
                }
            }
            // Set the updated modules array to state
            setModules(updatedModules);

        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };


    const handleAssessmentClick = async (assessment) => {
        try {
            setLoader(true);
            setContentType("assessment");

            const data = await getQuestionsByAssessment(assessment);
            if (data?.success) {
                setQuestions(data?.result);
            } else {
                toast.error(data?.message);
            }


        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    return (
        <>
            {loader ? (
                <Loader />
            ) : ("")}

            <Layout tab={2}>
                <WatchCourse fetchCourse={fetchCourse} setLoader={setLoader} handleVideoEnd={handleVideoEnd} fetchModuleProgress={fetchModuleProgress} course={course} modules={modules} gl={handleGenerateLink} cl={contentLink} ct={contentType} cd={contentDescription} loader={loader} ac={handleAssessmentClick} moduleIndex={moduleIndex} lessonIndex={lessonIndex} setLessonIndex={setLessonIndex} setModuleIndex={setModuleIndex} questions={questions} />
            </Layout >
        </>
    )
}

export default MyCourseView;